import apiPaths from '../api-paths.js';

export default {
  index() {
    return axios.get(`${ apiPaths.CRM }/industry-type`);
  },
};
